/*
  Behaviour for Leonard Silver homepage sections. No dependencies; each part is inert
  if its section isn't on the page.
*/
(() => {
  // Product tabs: WAI-ARIA tabs pattern (click, arrow keys, Home/End).
  function initTabs(root) {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const allLink = root.querySelector('[data-ls-tabs-all]');
    if (!tabs.length) return;

    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const selected = t === tab;
        t.setAttribute('aria-selected', String(selected));
        t.tabIndex = selected ? 0 : -1;
        const panel = root.querySelector(`#${t.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = !selected;
      });
      if (allLink && tab.dataset.url) allLink.href = tab.dataset.url;
      if (focus) tab.focus();
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (e) => {
        const keys = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 };
        if (!(e.key in keys)) return;
        e.preventDefault();
        select(tabs[(keys[e.key] + tabs.length) % tabs.length], true);
      });
    });
  }

  // Style Guru question box: opens the chat with the question; without the app it falls back to search.
  function initGuru(form) {
    form.addEventListener('submit', (e) => {
      if (typeof window.StyleGuru?.open !== 'function') return;
      e.preventDefault();
      window.StyleGuru.open(form.querySelector('input')?.value.trim() || '');
    });
  }

  // Klaviyo newsletter (client subscriptions API, public site ID only).
  function initKlaviyo(form) {
    const status = form.querySelector('.ls-newsletter__status');
    const button = form.querySelector('button[type="submit"]');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = form.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        status.textContent = 'Please enter a valid email address.';
        form.email.setAttribute('aria-invalid', 'true');
        form.email.focus();
        return;
      }
      form.email.removeAttribute('aria-invalid');
      button.disabled = true;
      status.textContent = 'Signing you up…';
      try {
        const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(form.dataset.company)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Website footer sign-up',
                profile: { data: { type: 'profile', attributes: { email } } },
              },
              relationships: { list: { data: { type: 'list', id: form.dataset.list } } },
            },
          }),
        });
        if (!res.ok) throw new Error(String(res.status));
        form.reset();
        status.textContent = 'Nearly there. Check your inbox to confirm your subscription.';
      } catch (err) {
        status.textContent = 'Sorry, that didn’t work. Please try again.';
      } finally {
        button.disabled = false;
      }
    });
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-ls-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-ls-guru-form]').forEach(initGuru);
    scope.querySelectorAll('[data-ls-klaviyo]').forEach(initKlaviyo);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
